import generateTypes from 'redux/utils/generateTypes';

export const LOGIN = generateTypes('LOGIN');
export const LOGOUT = 'LOGOUT';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const UPDATE_LOGOUT_PERFORM_STATE = 'UPDATE_LOGOUT_PERFORM_STATE';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
